import { Box, Modal, Text, ActionIcon } from '@cowbell/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { JsonViewerContent } from './JsonViewerContent';
import classes from './JsonViewerModal.module.css';

interface JsonViewerModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly data: unknown;
}

/** Full-viewport modal presentation of the extracted-data JSON. The toolbar,
 *  search and tree/raw viewer live in the shared `JsonViewerContent`; this
 *  wrapper only supplies the modal frame, title and close control. The Ask Moo
 *  `JsonViewerPanel` reuses the same content in a slide-out drawer. */
export const JsonViewerModal = ({
  open,
  onClose,
  data,
}: JsonViewerModalProps) => (
  <Modal
    opened={open}
    onClose={onClose}
    size="75rem"
    withCloseButton={false}
    zIndex={9999}
    classNames={{
      content: classes.modalContent,
      body: classes.modalBody,
    }}
    styles={{
      inner: { position: 'fixed', inset: 0 },
    }}
  >
    <Box className={classes.header}>
      <Text fw={600} size="lg">
        Extracted Data
      </Text>
      <ActionIcon variant="subtle" size="sm" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </ActionIcon>
    </Box>
    <JsonViewerContent data={data} />
  </Modal>
);
